import responsiveVideo from "../components/_responsive-video";

responsiveVideo();
